var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7824 4.51686L11.4741 2.0252C10.6491 1.5502 9.35742 1.5502 8.53242 2.0252L4.18242 4.53353C2.45742 5.7002 2.35742 5.8752 2.35742 7.73353V12.2585C2.35742 14.1169 2.45742 14.3002 4.21576 15.4835L8.52409 17.9752C8.94076 18.2169 9.47409 18.3335 9.99909 18.3335C10.5241 18.3335 11.0574 18.2169 11.4658 17.9752L15.8158 15.4669C17.5408 14.3002 17.6408 14.1252 17.6408 12.2669V7.73353C17.6408 5.8752 17.5408 5.7002 15.7824 4.51686ZM9.99909 12.7085C8.50742 12.7085 7.29076 11.4919 7.29076 10.0002C7.29076 8.50853 8.50742 7.29186 9.99909 7.29186C11.4908 7.29186 12.7074 8.50853 12.7074 10.0002C12.7074 11.4919 11.4908 12.7085 9.99909 12.7085Z",
    fill: "#1B1924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsLight);
export default __webpack_public_path__ + "static/media/settings-light.a51ece6ec7fd8ed1cbf61dc08dc8ddea.svg";
export { ForwardRef as ReactComponent };